import { Box } from '@material-ui/core';
import React, { FC } from 'react';
import { CreateButton } from 'react-admin';

const UsersListTittle: FC = () => {
    return (
        <Box marginTop="2em">
            <div className="active-prizes-container">
                User Management
        </div>
            <Box display="flex" justifyContent="flex-end">
            <CreateButton className="add-button" label="Add new " to='users/create' />
        </Box>
        </Box>
    )
}

export default UsersListTittle